<link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500&display=swap" rel="stylesheet">
<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
<link href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet">


<mat-card>
  <mat-card-header>
    <mat-card-title id="header">
      <h1>
        Document Directory
        <span flex></span>
        <button mat-raised-button class="fileroom-button fileroom-upload-button" (click)="openUploadDialog()">
          Upload New <mat-icon class="fileroom-upload-button-add-align">add</mat-icon>
        </button>
      </h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="searchForm">
      <mat-form-field appearance="outline">
        <mat-label>Keywords</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput name="keyword" formControlName="keyword" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Tags</mat-label>
        <mat-select name="tags" formControlName="tags" multiple>
          <mat-option>All</mat-option>
          <mat-option *ngFor="let tag of this.tags" [value]="tag.name">
            {{ tag.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Department</mat-label>
        <mat-select name="department" formControlName="department" multiple>
          <mat-option>All</mat-option>
          <mat-option *ngFor="let dept of this.departments" [value]="dept.name">
            {{ dept.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate placeholder="Start date" name="startDate" formControlName="startDate" />
          <input matEndDate placeholder="End date" name="endDate" formControlName="endDate" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker color="accent"></mat-date-range-picker>
      </mat-form-field>
      <button class="fileroom-button fileroom-search-button" mat-raised-button (click)="onSearch()">Search</button>
    </form>

    <mat-chip-list #chipList aria-label="search selection">
      <mat-chip *ngFor="let chip of this.chips" (removed)="this.removeSearchCriterion(chip.value, chip.type)">
        {{ chip.value }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    </mat-chip-list>
  </mat-card-content>
</mat-card>

<div><p></p></div>
<div><p></p></div>

<mat-card>
  <mat-card-content>
    <div>
      <mat-table [dataSource]="filesDatasource" matSort>
        <ng-container matColumnDef="extension">
          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
          <mat-cell *matCellDef="let file">
            <span class="fileroom-extension {{ file.extension }} ">{{ file.extension }} </span></mat-cell
          >
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
          <mat-cell *matCellDef="let file">
            <a (click)="this.viewFile(file.id, file.name)">
              {{ file.name }}
            </a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="tags">
          <mat-header-cell *matHeaderCellDef>Tags</mat-header-cell>
          <mat-cell *matCellDef="let file">
            <mat-form-field appearance="outline" *ngIf="file.isEditing">
              <mat-label>Tags</mat-label>
              <mat-select multiple>
                <mat-option>All</mat-option>
                <mat-option *ngFor="let tag of this.tags" [(value)]="file.tags[tag]">
                  {{ tag.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <span *ngIf="!file.isEditing"> {{ file.tags.length > 20 ? file.tags.slice(0, 20) + '...' : file.tags }}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="department">
          <mat-header-cell *matHeaderCellDef> Department </mat-header-cell>
          <mat-cell *matCellDef="let file">
            <mat-form-field appearance="outline" *ngIf="file.isEditing">
              <mat-label>Department</mat-label>
              <mat-select name="department" multiple value="{{ file.department }}">
                <mat-option>All</mat-option>
                <mat-option *ngFor="let dept of this.departments" [value]="dept.name">
                  {{ dept.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <span *ngIf="!file.isEditing"> {{ file.department }}</span>
          </mat-cell>
        </ng-container>

        <ng-container *ngIf="this.actions.length > 0" matColumnDef="customActions">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let file">
            <span *ngFor="let action of this.getActionsWithoutFlyouts()">
              <button *ngIf="action.type === 'button'" mat-menu-item class="fileroom-button-flat blue" (click)="runAction(action, file)">
                <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon
                ><span *ngIf="action.displayText">{{ action.name }}</span>
              </button>
              <mat-slide-toggle *ngIf="action.type === 'toggle'" (click)="runAction(action, file)">
                {{ action.name }}
              </mat-slide-toggle>
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="lastModified">
          <mat-header-cell *matHeaderCellDef> Last Modified</mat-header-cell>
          <mat-cell *matCellDef="let file">
            {{ file.createdOn | date : 'medium' }} by {{ file.createdBy == null ? 'unknown' : file.createdBy }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="actions" stickyEnd>
          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
          <mat-cell *matCellDef="let file">
            <div *ngIf="file.isEditing">
              <span mat-icon-button style="display: inline-block; cursor: pointer" class="fileroom-row-action">
                <mat-icon (click)="this.save(file.id)" style="color: #00bcd4">check_circle</mat-icon>
              </span>
            </div>
            <div *ngIf="!file.isEditing">
              <span mat-icon-button style="display: inline-block; cursor: pointer" class="fileroom-row-action">
                <mat-icon (click)="this.downloadFile(file.id, file.contentType, file.name)">cloud_download</mat-icon>
              </span>

              <span mat-icon-button [matMenuTriggerFor]="appMenu" class="fileroom-row-action">
                <mat-icon>more_vert</mat-icon>
              </span>

              <mat-menu #appMenu="matMenu">
                <ng-template matMenuContent>
                  <button mat-menu-item class="fileroom-button-flat blue" (click)="edit(file.id)">Edit</button>
                  <hr class="fileroom-menu-seperator" />
                  <button mat-menu-item class="fileroom-button-flat red" (click)="deleteById(file.id)">Delete</button>

                  <hr *ngIf="this.flyoutActions.length > 0" class="fileroom-menu-seperator" />
                  <button
                    *ngFor="let action of this.flyoutActions"
                    mat-menu-item
                    class="fileroom-button-flat blue"
                    (click)="runAction(action, file)"
                  >
                    <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon> {{ action.name }}
                  </button>
                </ng-template>
              </mat-menu>
            </div>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No data matching the filters selected.</td>
        </tr>
      </mat-table>
    </div>
  </mat-card-content>
  <mat-card-footer>
    <mat-paginator
      appearance="default"
      [length]="files.length"
      [pageSize]="this.pageSize"
      [pageSizeOptions]="[3, 5, 10, 20]"
      showFirstLastButtons
    ></mat-paginator>
  </mat-card-footer>
</mat-card>
